import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ShieldIcon from '@mui/icons-material/Shield';
import { useTranslation } from 'react-i18next';
import DefensiveVersatilityChart from '../DefensiveVersatility/DefensiveVersatilityChart';
import DefensiveVersatilityEditor from '../DefensiveVersatility/DefensiveVersatilityEditor';
import { normalizeVersatility, hasAnyValue } from '../../utils/versatility';

/**
 * Section "Defensive Versatility" inside the player profile.
 * Mirrors the visual style of CaracteristicasJugador / SituacionActual (Paper container with section title).
 *
 * Props:
 *  - player           : current player (read mode source)
 *  - editablePlayer   : edit-mode draft
 *  - setEditablePlayer: setter
 *  - isEditing        : edit mode toggle
 *  - isMobile         : layout flag (kept for parity with sibling sections, currently same render)
 */
const DefensiveVersatilitySection = ({ player, editablePlayer, setEditablePlayer, isEditing, isMobile }) => {
  const { t } = useTranslation();
  const value = isEditing ? editablePlayer?.defensive_versatility : player?.defensive_versatility;

  // Don't render the section in read mode when nothing has been filled in
  if (!isEditing && !hasAnyValue(normalizeVersatility(value))) return null;

  return (
    <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <ShieldIcon sx={{ color: 'primary.main' }} />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {t('defensiveVersatility.title')}
        </Typography>
      </Box>

      {isEditing ? (
        <DefensiveVersatilityEditor
          value={value}
          onChange={(next) => setEditablePlayer(prev => ({ ...prev, defensive_versatility: next }))}
          showTitle={false}
        />
      ) : (
        <DefensiveVersatilityChart value={normalizeVersatility(value)} />
      )}
    </Paper>
  );
};

export default DefensiveVersatilitySection;
